/**
 * QuizTestPage 상수 정의
 */
import type { QuizTestLabels } from './types'
import { QUEBOARD_QUIZ_PRESETS } from '../tools/QueBoard/quizPresets'

/** 기본 퀴즈 ID (타입별) */
export const QUIZ_IDS_BY_TYPE = {
  fill_blank: ['21238150823153687', '11308742893326359', '4690122987129947', '299299243067424'],
  multi_choice: ['19837706214260337', '19730076867181710', '19731068920740901', '19730975438093334'],
  select_text: ['2718018757512453', '8516693397164568'],
  boolean: ['5415003651285133', '19837808404283007'],
  drag_text: ['8046920963605206', '1761739886108674'],
  coloring: ['16795729986487345', '16744044617011419', '14354433162249985'],
  counting: ['12732455874204045', '13194544317206675', '13671831324070452'],
  image_select: ['1254039175305218', '1254145719015733', '1254168938683097'],
  ordering: ['20498180186998395', '1192223530258532', '1254131189946669'],
  pairing: ['4392871645980679', '3133395605965950', '4649464049934338'],
} as const

/** 새 UI용 퀴즈 ID */
export const QUIZ_IDS_NEW_UI = {
  multi_choice: ['11871960040476691'],
  fill_blank: ['19071380608728267'],
  select_text: ['17288276668220516'],
} as const

/** 새 UI 퀴즈 ID Set */
export const NEW_UI_QUIZ_IDS_SET = new Set<string>(
  Object.values(QUIZ_IDS_NEW_UI).flat() as string[]
)

/** 퀴즈 타입 라벨 */
export const QUIZ_TYPE_LABELS = {
  fill_blank: 'FillBlank',
  multi_choice: 'MultiChoice',
  select_text: 'SelectText',
  boolean: 'Boolean',
  drag_text: 'DragText',
  coloring: 'Coloring',
  counting: 'Counting',
  image_select: 'ImageSelect',
  ordering: 'Ordering',
  pairing: 'Pairing',
} as const

/** 한국어 기본 텍스트 (i18n 미제공 시 fallback) */
export const DEFAULT_LABELS: QuizTestLabels = {
  invalidJson: '유효하지 않은 JSON 형식입니다.',
  enterQuizId: '퀴즈 ID를 입력해주세요.',
  fetchFailed: '퀴즈를 불러오는데 실패했습니다. ID를 확인해주세요.',
  description: '퀴즈 ID를 입력하여 개별 퀴즈를 테스트할 수 있습니다. 개발 환경에서만 사용 가능합니다.',
  quickSelect: '빠른 선택',
  newUiByType: '새 UI (타입별)',
  quizIdLabel: '퀴즈 ID',
  quizIdPlaceholder: '퀴즈 ID를 입력하세요',
  search: '조회',
  advancedOptions: '고급 옵션',
  newUiComponent: '새 UI 컴포넌트',
  solving: '채점 중...',
  loading: '퀴즈를 불러오는 중...',
  reset: '초기화',
}

export function isNewUiQuiz(quizId: string | number | null | undefined): boolean {
  if (quizId == null) return false
  return NEW_UI_QUIZ_IDS_SET.has(String(quizId))
}

/** 깨보드 퀴즈 ID (카테고리별 그룹) - quizPresets.ts 주석 기반 */
export const QUEBOARD_QUIZ_GROUPS: Record<string, string[]> = {
  '텔레포트 (10기준): 곱하기 9, 합도 9': [
    '12732429441700235',
    '16916731184287809',
    '16916902412554384',
    '12732401818014088',
    '16880841867137459',
    '12735301021601798',
    '16894755078148856',
  ],
  '텔레포트 (10기준): 5×9': ['12821822500245602'],
  '텔레포트 (10기준): 8×8, 구구단 절대 외우지 마라': [
    '12735156502663301',
    '16880971907338721',
    '15062795783508778',
    '13279254822683854',
    '13279255854482639',
  ],
  '텔레포트 (10기준): 다이어그램으로': [
    '12735339382706188',
    '16881024629740015',
    '13279252960412876',
  ],
  '텔레포트 (10기준): 6×8': ['12809274568741801'],
  '텔레포트 (5기준): 쉬운 타깃네모를 골라라': [
    '13279250536105162',
    '16894779883262717',
    '14815420766753037',
  ],
  '은행: 4×9': ['16881557826441835'],
}

/** 깨보드 프리셋이 있는 모든 퀴즈 ID Set */
export const QUEBOARD_QUIZ_IDS_SET = new Set<string>(Object.keys(QUEBOARD_QUIZ_PRESETS))
